// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2j0ha","upload":"Small_upload__3fzmF","imageWrap":"Small_imageWrap__2UBHj","removeBtn":"Small_removeBtn__2X4MK"};